import { createSlice } from '@reduxjs/toolkit';
import { UiState as UiStateEnum } from 'constants/ui';
import { PickupModalElement, stateName } from '../constants';
export const initialPickupModalUiState = {
  [PickupModalElement.Modal]: UiStateEnum.Idle,
  [PickupModalElement.SearchArea]: UiStateEnum.Idle,
  [PickupModalElement.UserLocation]: UiStateEnum.Idle,
  [PickupModalElement.Search]: UiStateEnum.Idle
};
export const initialDeliveryUiState = {
  deliveryTypes: UiStateEnum.Idle
};
export const initialUiState = {
  pickupModal: initialPickupModalUiState,
  pickupPoints: UiStateEnum.Idle
};
export const initialState = {
  countryBounds: null,
  nearbyPoints: [],
  ui: initialUiState,
  suggestedShippingPointCode: null,
  selectedShippingPoint: null,
  shippingOptions: []
};

const fetchCountryBoundsSuccess = (draft, action) => {
  const {
    countryBounds
  } = action.payload;
  draft.countryBounds = countryBounds;
};

const fetchNearbyShippingPointsRequest = draft => {
  draft.ui.pickupModal = initialPickupModalUiState;
  draft.ui.pickupPoints = UiStateEnum.Pending;
  draft.selectedShippingPoint = null;
};

const fetchNearbyShippingOptionsFailure = draft => {
  draft.nearbyPoints = [];
  draft.ui.pickupPoints = UiStateEnum.Failure;
};

const setPickupModalElementUiState = (draft, action) => {
  const {
    element,
    uiState
  } = action.payload;
  draft.ui.pickupModal[element] = uiState;
};

const setSelectedShippingPoint = (draft, action) => {
  const {
    selectedShippingPoint
  } = action.payload;
  draft.selectedShippingPoint = selectedShippingPoint;
};

const resetPickupPointsUiState = draft => {
  draft.ui.pickupPoints = UiStateEnum.Idle;
}; // an edge case when changing physical authenticity flag displays stale data in the pickup map


const resetShippingOptions = draft => {
  draft.ui.pickupModal = initialPickupModalUiState;
  draft.ui.pickupPoints = UiStateEnum.Idle;
  draft.countryBounds = null;
  draft.nearbyPoints = [];
  draft.suggestedShippingPointCode = null;
  draft.selectedShippingPoint = null;
  draft.shippingOptions = [];
};

const fetchNearbyShippingOptionsSuccess = (draft, action) => {
  const {
    nearbyShippingPoints,
    nearbyShippingOptions,
    suggestedShippingPointCode,
    suggestedRateUuid
  } = action.payload;
  draft.nearbyPoints = nearbyShippingPoints;
  draft.shippingOptions = nearbyShippingOptions;
  draft.suggestedShippingPointCode = suggestedShippingPointCode;
  draft.suggestedRateUuid = suggestedRateUuid;
  draft.ui.pickupPoints = UiStateEnum.Success;
};

const setSelectedServiceType = (draft, action) => {
  const {
    serviceType
  } = action.payload;
  draft.selectedServiceType = serviceType;
};

const shippingSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchCountryBoundsSuccess,
    fetchNearbyShippingPointsRequest,
    fetchNearbyShippingOptionsFailure,
    setPickupModalElementUiState,
    setSelectedShippingPoint,
    resetPickupPointsUiState,
    fetchNearbyShippingOptionsSuccess,
    resetShippingOptions,
    setSelectedServiceType
  }
});
export const {
  actions
} = shippingSlice;
export const plug = {
  [stateName]: shippingSlice.reducer
};
export default shippingSlice.reducer;